const COOKIE_KEY = 'cookieAgrement';

export default COOKIE_KEY;



// WEBPACK FOOTER //
// ./src/common/consts/cookies.js